var _circle, _g, _g2, _circle2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcBuy1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 36,
    fill: "#13AE67",
    fillOpacity: 0.08
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4551_75590)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 43L18 46",
    stroke: "white",
    strokeOpacity: 0.61,
    strokeWidth: 1.57256,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46 43L49 46",
    stroke: "white",
    strokeOpacity: 0.61,
    strokeWidth: 1.57256,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_4551_75590)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 19,
    width: 39,
    height: 25,
    rx: 4,
    fill: "white",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.7863,
    y: 19.7863,
    width: 37.4274,
    height: 23.4274,
    rx: 3.21372,
    stroke: "url(#paint0_linear_4551_75590)",
    strokeWidth: 1.57256
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_b_4551_75590)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 24,
    width: 19,
    height: 30,
    rx: 4,
    fill: "white",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.7863,
    y: 24.7863,
    width: 17.4274,
    height: 28.4274,
    rx: 3.21372,
    stroke: "url(#paint1_linear_4551_75590)",
    strokeWidth: 1.57256
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 28,
    r: 1,
    fill: "#D7D7D7"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4551_75590",
    x: 1.41954,
    y: 9.56465,
    width: 64.1609,
    height: 52.9471,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.14512
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.29023
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4551_75590"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4551_75590",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_4551_75590",
    x: 10.8549,
    y: 15.8549,
    width: 45.2902,
    height: 31.2902,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1.57256
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_4551_75590"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_4551_75590",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_b_4551_75590",
    x: 35.8549,
    y: 20.8549,
    width: 25.2902,
    height: 36.2902,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1.57256
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_4551_75590"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_4551_75590",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4551_75590",
    x1: 16.6095,
    y1: 19,
    x2: 53.5651,
    y2: 43.1347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4551_75590",
    x1: 40.2713,
    y1: 24,
    x2: 64.2672,
    y2: 30.3622,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBuy1);
export default __webpack_public_path__ + "static/media/ic-buy1.9a7c4d151ade758a764fb8f6ac34015a.svg";
export { ForwardRef as ReactComponent };